import React, { useEffect } from "react";
import { useState } from "reinspect";
import ArticlesGeneriques from "../components/Articles/ArticlesGeneriques";
import ArticlesList from "../components/Articles/ArticlesList";
import { useCriteresListManager } from "../components/Articles/useCriteresListManager";
import { useVrpRedirect } from "../components/Auth/useVrpRedirect";
import ApplicationHeader from "../components/Headers/ApplicationHeader/ApplicationHeader";
import { useAPIManager } from "../components/lib/APIManager";
import FSLoader from "../components/Loaders/FSLoader";
import Page from "../components/Page/Page";
import SidebarCategories from "../components/SidebarCategories/SidebarCategories";
import SidebarControls from "../components/SidebarControls/SidebarControls";
import confs from "../configurations";
import { navigate } from "../routes";
import { admin } from "../routes/admin";
import { main } from "../routes/main";
import { useDispatch } from "react-redux";
import "./AppNavigation.css";
import { types } from "../components/Auth/reducer";

const { URL_API } = confs;

function AppNavigation(props) {
  useVrpRedirect();

  const dispatch = useDispatch();
  const { critere } = props.match.params;

  const [ok, isOk] = useState(false);
  const [activeItem, setActiveItem] = useState();
  const [search_criteria, set_search_criteria] = useState();
  const [selectedGen, setSelectedGen] = useState();
  const [articleOpen, setArticleOpen] = useState(false);
  const [selected_criteres, selectCritere, resetCritere] =
    useCriteresListManager();
  const [fags, fagsMethods] = useAPIManager({
    baseUrl: URL_API,
    ressource: {
      name: "fags",
      key: "CODFAG",
    },
    defaultHeaders: {
      "Content-type": "application/json",
      Authorization: (state) => state.auth && "Bearer " + state.auth.token,
    },
  });

  window.onpopstate = function (event) {
    if (event.state && articleOpen) {
      navigate.replace(admin.APP_NAVIGATION, {
        critere: activeItem.CODFAG || fags.collection[0].CODFAG,
      });
      setArticleOpen(false);
    }
  };

  useEffect(() => {
    fagsMethods.getCollection({ testeurs_plvs: "N" });
  }, []);

  function modifySearchCriteria(value) {
    if (!value || value === "") {
      set_search_criteria(undefined);
    } else {
      set_search_criteria(value);
    }
  }

  useEffect(() => {
    if (fags.collection && critere) {
      if (critere === "start") {
        navigate.replace(admin.APP_NAVIGATION, {
          critere: fags.collection[0].CODFAG,
        });
      } else {
        let selectedItem = fags.collection.find((it) => it.CODFAG === critere);
        if (!selectedItem) {
          navigate.push(main.NOT_FOUND);
          return;
        }
        _selectItem(selectedItem);
        isOk(true);
      }
    }
  }, [fags.collection, critere]);

  const _selectItem = (fag) => {
    setActiveItem(fag);
    if (fag.CODFAG !== critere) {
      dispatch({ type: types.UPDATE_NAVIGATION_CODFAG, payload: fag.CODFAG });
      navigate.push(admin.APP_NAVIGATION, { critere: fag.CODFAG });
    }
  };

  if (!ok) return <FSLoader fullHeight />;

  function renderArticleslist() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    return (
      <React.Fragment>
        <Page>
          <ArticlesList
            gen_articles={selectedGen}
            selected_criteres={selected_criteres}
            isPack={selectedGen?.TYPGEN === "PACK"}
            closeModal={() => setArticleOpen(false)}
          />
        </Page>
      </React.Fragment>
    );
  }

  function renderProducts() {
    return (
      <React.Fragment>
        <SidebarControls
          selectItem={_selectItem}
          items={fags.collection}
          codfag={activeItem.CODFAG}
          set_search_criteria={modifySearchCriteria}
          selected_criteres={selected_criteres}
          selectCritere={selectCritere}
          resetCritere={resetCritere}
          search_value={search_criteria}
        />
        <Page>
          <ArticlesGeneriques
            codfag={activeItem.CODFAG}
            search_criteria={search_criteria}
            selected_criteres={selected_criteres}
            selectCritere={selectCritere}
            resetCritere={resetCritere}
            articleOpen={() => setArticleOpen(true)}
            gen_articles={setSelectedGen}
          />
        </Page>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <ApplicationHeader headerConfig={{ showcart: true }} />
      <div className="app-navigation-page">
        <div className="app-navigation-right-sidebar">
          <SidebarCategories
            selectItem={_selectItem}
            items={fags.collection}
            codfag={activeItem.CODFAG}
            search_criteria={modifySearchCriteria}
            search_value={search_criteria}
            closeModal={() => setArticleOpen(false)}
          />
        </div>
        <div className="app-navigation-left-container">
          {articleOpen ? renderArticleslist() : renderProducts()}
        </div>
      </div>
    </React.Fragment>
  );
}

export default AppNavigation;
